import {connect} from 'react-redux';
import {Card, Col, Row} from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import PropertyDropdown from './components/PropertyDropdown';
import PropertyRadio from './components/PropertyRadio';
import {RGBW} from '../../../../../../utils/constantFeatures';

class RGBWAF extends BaseFeature {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
    }

    handleChange(propertyName, value) {
        this.props.handleChange(propertyName, value);
        if(propertyName === 'rgbw.pctr'){
            this.props.handleChange('rgbw.sctr', value);
        }
    }

    handleColorChange(e) {
        const value = e.target.value;
        const name = e.target.name;
        this.props.handleChange(name, value);
    }

    render() {

        const title = this.props.properties[RGBW.channel].info['displayName'];

        return (
            <div>
                <div className="flex-row">
                    <Card>
                        <div className="card-header-feature">
                            {title}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyDropdown
                                property={this.props.properties[RGBW.channel]}
                                properties={this.props.properties[RGBW.channel].valueMeta.availableValues}
                                type={'rgbw'}
                                title={'Mode'}
                                measureUnit={''}
                                handleChange={this.handleChange}
                            />
                        </Card.Body>
                    </Card>
                    <Card style={{ width: '20%' }}>
                        <div className="card-header-feature">
                            {"Color Control"}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyRadio
                                property={this.props.properties['rgbw.pctr']}
                                valueForTrue={['Normalized']}
                                isChecked={this.props.properties['rgbw.pctr'].value === 'Normalized'}
                                title={'Normalized'}
                                handleChange={this.handleChange} />
                            <PropertyRadio
                                property={this.props.properties['rgbw.pctr']}
                                valueForTrue={['Extended']}
                                isChecked={this.props.properties['rgbw.pctr'].value === 'Extended'}
                                title={'Extended'}
                                handleChange={this.handleChange} />

                            <Row>
                                <Col>
                                    <span>Warning: Total driver output power might be significantly higher when selecting Color Control -&gt; “Extended” (depending on RGBW weighting factors in color settings)</span>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <div className="card-header-feature">
                            {"Color"}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>

                            <Row style={{ margin: "0.75rem auto 0" }}>
                                <Col sm={3} style={{ padding: '0', margin: "auto 0" }}>
                                    {this.props.properties['rgbw.pcol'].info.displayName}
                                </Col>
                                <Col sm={9} style={{ margin: "auto 0" }}>
                                    <input
                                        style={{ width: "100px" }}
                                        disabled={false}
                                        className={'input-property-picker'}
                                        name={this.props.properties['rgbw.pcol'].info.name}
                                        type="text"
                                        value={this.props.properties['rgbw.pcol'].value}
                                        onChange={this.handleColorChange} />
                                </Col>
                            </Row>
                            <Row style={{ margin: "0.75rem auto 0" }}>
                                <Col sm={3} style={{ padding: '0', margin: "auto 0" }}>
                                    {this.props.properties['rgbw.scol'].info.displayName}
                                </Col>
                                <Col sm={9} style={{ margin: "auto 0" }}>
                                    <input
                                        style={{ width: "100px" }}
                                        disabled={false}
                                        className={'input-property-picker'}
                                        name={this.props.properties['rgbw.scol'].info.name}
                                        type="text"
                                        value={this.props.properties['rgbw.scol'].value}
                                        onChange={this.handleColorChange} />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>Level of each channel represented by one hexadecimal byte "00" .. "FE" or "FF"=mask (keep last value)</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>Syntax: 4 bytes for 4 channels r(red), g(reen), b(blue), w(white - ignored, if RGB mode selected)</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>e.g. r=0%, g=100%, b=keep, w=100% --&gt; "00FEFFFE"</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>Please check DALI standard 209 for details</span>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                </div>
            </div>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(RGBWAF);
